module.exports = __webpack_public_path__ + "img/planner.42542545.png";